export const STATIC = 'STATIC';



// WEBPACK FOOTER //
// ./src/store/modules/image/mutation-types.js